import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forecast";
import axios from "axios";
import "./Weather.css";

export default function Weather(props) {
	const [weatherData, setWeatherData] = useState({ ready: false });
	const [city, setCity] = useState(props.defaultCity);

	function handleResponse(response) {
		setWeatherData({
			ready: true,
			city: response.data.name,
			date: new Date(response.data.dt * 1000),
			description: response.data.weather[0].description,
			temperature: Math.round(response.data.main.temp),
			humidity: Math.round(response.data.main.humidity),
			wind: Math.round(response.data.wind.speed),
			icon: `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
			lat: response.data.coord.lat,
      lon: response.data.coord.lon,
		});
	}

	function search() {
		const apiKey = "3f4a81b7800c9c7008887814c1af70f7";
		let units = "metric";
		let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=${units}`;
		axios.get(apiUrl).then(handleResponse);
	}

	function handleSubmit(event) {
		event.preventDefault();
		search();
	}

	function updateCity(event) {
		setCity(event.target.value);
	}

	function currentLocation(position){
    const apiKey = "3f4a81b7800c9c7008887814c1af70f7";
    let latitude = position.coords.latitude;
    let longitude = position.coords.longitude;
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric&lang=en`;
		
		axios.get(apiUrl).then(handleResponse);
  }

  function handleLocation(event){
    event.preventDefault();
    navigator.geolocation.getCurrentPosition(currentLocation)
  }

	if (weatherData.ready) {
		return (<div className="weather-app">
			<form onSubmit={handleSubmit}>
				<div className="row m-1 justify-content-center">
					<div className="col-4 no-padding">
						<input type="search" placeholder="Enter city" className="form-control" autoFocus="on" onChange={updateCity} />
					</div>
					<div className="col-auto no-padding pl-1">
						<input type="submit" value="Search" className="btn btn-secondary" />
					</div>
					<div className="col-auto pl-1">
						<input type="submit" value="Current Location" className="btn btn-secondary" onClick={handleLocation} />
					</div>
				</div>
			</form>
			<WeatherInfo data={weatherData} />
			<hr />
			<Forecast city={weatherData.city} />
		</div>   
  );
	} else {
		search();
		return (<div>This app is loading...</div>);
	}
}